import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useUserContext } from 'context'
import { Caption, Flex, HR, ResponsiveSVG } from 'ui/acro'
import AppStoreComponent from '../../../common/AppStoreComponent'
import { AloMovesLogo } from 'images/latest'
import CommonLink from 'components_v2/CommonLink'

const ListItem = styled(Caption)({
  position: 'relative',
  paddingTop: '10px',
  paddingBottom: '10px',
  fontSize: '15px',
  whiteSpace: 'nowrap',
  fontWeight: 600
})

// Legacy hack alert!
// If specifying 'color' prop on anchor tags in the nav or footer on legacy pages, it will be overriden by 'color: inherit' (see ThemeWrapper)
// Using &&& increases specificity by applying the class three times, making it take precedence
const GreyListItem = styled(ListItem)`
  &&& {
    color: ${(props) => props.theme.colors.grey4};
  }
`

// ListItem for name is a <div/> so that legacy application.css won't try to style it (renders as h4 by default)

const ProfileMenu = ({ onShowReferral }) => {
  const { user } = useUserContext()

  return (
    <>
      <Flex flexDirection='column'>
        {user.firstName && (
          <Fragment>
            <GreyListItem as='div' variant='bold' pt='0px'>
              {user.firstName}
            </GreyListItem>
            <HR my='10px' />
          </Fragment>
        )}
        <ListItem
          id='navbar-my-profile-link'
          as='a'
          href={`/users/${user.username}`}
          className='unstyled'
          variant='medium'
          style={{ display: 'none' }}
        >
          My Profile
        </ListItem>
        <ListItem
          as='a'
          href='/settings/profile'
          className='unstyled'
          variant='medium'
        >
          Settings
        </ListItem>

        <HR my='10px' />
        {user && user?.aloLinkedStatus && (
          <ListItem
            as='a'
            href={window.REACT_ENV_VARIABLES.ALO_POINTS_PAGE_URL}
            target='_blank'
            className='unstyled'
            variant='medium'
          >
            ALO Access
          </ListItem>
        )}
        <ListItem
          as='a'
          href='/alo_shop_si_web'
          className='unstyled'
          variant='medium'
          id='alo_shop_si_web'
          rel='noopener noreferrer'
          target='_blank'
        >
          Shop
          <ResponsiveSVG
            marginLeft={'0.5rem'}
            SVG={AloMovesLogo}
            width='1.7rem'
            height='1.5rem'
          />
        </ListItem>

        <HR my='10px' />

        <ListItem
          as='div'
          className='unstyled'
          variant='medium'
          style={{ cursor: 'pointer' }}
          onClick={onShowReferral}
        >
          Refer a Friend
        </ListItem>
        <ListItem
          as={CommonLink}
          to='/support'
          className='unstyled'
          variant='medium'
        >
          Get Help
        </ListItem>
        <ListItem
          as='a'
          href='/signout'
          id='nav_logout_desktop'
          className='unstyled'
          variant='medium'
          pb='0px'
        >
          sign out
        </ListItem>
        <HR my='10px' />
        <AppStoreComponent />
      </Flex>
    </>
  )
}

ProfileMenu.propTypes = {
  onShowReferral: PropTypes.func
}

export default ProfileMenu
